import React, { useState } from 'react';
import axios from 'axios';

export default function OccurModal({ data, onReceive, onClose }) {
  const [processingId, setProcessingId] = useState(null);
  const [showUserDetail, setShowUserDetail] = useState(false);
  const [userData, setUserData] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const token = localStorage.getItem('token');

  const handleReceiveClick = async (item) => {
    setProcessingId(item.id);
    await onReceive(item.alert_id); // 서버로 POST
    setProcessingId(null);
  };

  const handleOpenUserDetail = async (userId) => {
    setSelectedUserId(userId);
    setShowUserDetail(true);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserData(response.data.user); // 기존 UserDetail API 그대로 사용
    } catch (error) {
      console.error("사용자 상세정보 불러오기 실패:", error);
      alert("사용자 정보를 불러오지 못했습니다.");
      setShowUserDetail(false);
    }
  };

  const handleCloseUserDetail = () => {
    setShowUserDetail(false);
    setUserData(null);
  };

  return (
    <>
      <div className="modalbg"></div>
      <div className="modal occurmodal">
        <h3>발생현황</h3>
        <p className="red">※ 응급처치가 필요한 대상입니다. 접수하여 처리하세요.</p>
        <div className="table">
          {data.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>이름</th>
                  <th>주소</th>
                  <th>나이</th>
                  <th>성별</th>
                  <th>지병</th>
                  <th>발생시간</th>
                  <th>확인</th>
                  <th>상세정보</th>
                </tr>
              </thead>
              <tbody>
                {data.map(item => (
                  <tr key={`${item.id}-${item.alert_id}`}>
                    <td>{item.name}</td>
                    <td>{item.address}</td>
                    <td>{item.age}</td>
                    <td>{item.gender}</td>
                    <td>{item.status}</td>
                    <td>{item.create_date}</td>
                    <td className="okbutton">
                      <button
                        onClick={() => handleReceiveClick(item)}
                        disabled={processingId === item.id}
                      >
                        {processingId === item.id ? '확인 중...' : '확인'}
                      </button>
                    </td>
                    <td className="okbutton2">
                      <button onClick={() => handleOpenUserDetail(item.id)}>상세정보</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="no-data">발생한 응급상황이 없습니다.</div>
          )}
        </div>
        <div className="btn-group">
          <button onClick={onClose} className="btncolor01">확인</button>
        </div>
      </div>

      {/* 사용자 상세정보 모달 */}
      {showUserDetail && userData && (
        <>
          <div className="modalbg" onClick={handleCloseUserDetail}></div>
          <div className="modal user-detail-modal">
            <h3>{userData.name}님의 상세정보</h3>
            <ul>
              <li><strong>전화번호:</strong> {userData.phone || '-'}</li>
              <li><strong>담당관리:</strong> {userData.department_name || '-'}</li>
              <li>
                <strong>가족정보:</strong>{' '}
                {Array.isArray(userData.family) && userData.family.length > 0
                  ? userData.family.map((f, i) => <span key={i}>{f.family_info || '-'}</span>)
                  : '등록된 가족정보가 없습니다.'}
              </li>
              <li><strong>위험군 등급:</strong> {userData.sev_name || '-'}</li>
              <li><strong>응급상황 횟수:</strong> {userData.alert_count != null ? `${userData.alert_count}회` : '-'}</li>
            </ul>
            <div className="btn-group">
              <button onClick={handleCloseUserDetail} className="btncolor01">닫기</button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
